/**
 * Etiqueta — a pílula de título do ranking e de categoria de despesa (refino
 * final, 23/09/2026). Substitui o selo em PNG: é texto de verdade, lê com o
 * leitor de tela e acompanha o tamanho de fonte do aparelho.
 *
 * Altura 28, ícone 14, texto 12/700, nunca quebra linha. O tom é um par
 * fundo/texto de `@nv/tokens` (`labelTone`) — a tela escolhe o tom, não a cor.
 */
import type { LabelTone } from '@nv/tokens';

import { Icon, type IconName } from './icons';

export function Etiqueta({
  nome,
  icone,
  tom = 'coral',
  className = '',
  'data-testid': testId,
}: {
  nome: string;
  icone?: IconName;
  tom?: LabelTone;
  className?: string;
  'data-testid'?: string;
}) {
  return (
    <span className={`nv-etiqueta nv-etiqueta--${tom} ${className}`.trim()} data-testid={testId}>
      {icone && <Icon name={icone} size={14} />}
      {nome}
    </span>
  );
}
